import React, { useEffect } from 'react'
import { config } from 'config'
import { SocketContext } from 'hooks/socketContext'
import { createAppSocket } from 'helpers/socketClient'
import { useSocketCredentialSync } from 'hooks/useSocketCredentialSync'

const socket = createAppSocket(config.WEBSOCKET_HOST || '')

const useSocketProviderValue = () => {
  'use no memo'
  useSocketCredentialSync(socket)

  useEffect(() => {
    const onConnectError = () => {
      socket.io.opts.transports = ['websocket']
    }
    socket.on('connect_error', onConnectError)

    return () => {
      socket.off('connect_error', onConnectError)
    }
  }, [])

  useEffect(() => {
    const onHeartbeat = () => {
      // Intentionally empty: receiving the heartbeat keeps intermediate proxies alive
    }

    socket.on('heartbeat', onHeartbeat)

    return () => {
      socket.off('heartbeat', onHeartbeat)
    }
  }, [])
  return {
    socket
  }
}

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  'use no memo'
  const value = useSocketProviderValue()
  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
}
